import PartnersSection from "./PartnersSection";

export default PartnersSection;